<!-- https://8es9hr.axshare.com/#g=1&p=%E6%96%B0%E5%A2%9E_%E7%B7%A8%E8%BC%AF%E5%8F%B0%E5%B9%A3%E5%AE%9A%E5%AD%98%E5%96%AE -->
<!-- 新增_編輯台幣定存單 -->
<template>
    <div class="row">
        <div class="col-12">
            <ListForm
                api="coopNtDepositOrder"
                :id="id"
                labelPosition="top"
                formTitle="台幣定存單管理"
                :rules="rules"
                :recordToEdit="recordToEdit"
                :formType="formType"
                v-if="$route.meta.formKeepAlive"
                @endDateNotify="endDateNotify"
                ref="mainForm"
            ></ListForm>
            <router-view v-else></router-view>
            <el-dialog
                :visible.sync="dialogListForm"
                :modal-append-to-body="false"
                :append-to-body="true"
            >
                <ListForm
                    id="new"
                    api="coopTask"
                    labelPosition="top"
                    formTitle="工作管理"
                    :recordToEdit="currentEdit"
                    :formType="formTypeWork"
                    @goLink="goLink"
                    ref="formSave"
                >
                    <div slot="footer" class="dialog-footer"></div>
                </ListForm>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogListForm = false">取消</el-button>
                    <el-button type="primary" @click="saveDialogEdit">確定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";
import moment from "moment";

export default {
    name: "deposit_order_edit",
    components: { ListForm },
    data() {
        return {
            dialogListForm: false,
            // getData 回填期間為 true，用來擋掉初次載入觸發的到期日期重算
            isInitLoading: true,
            id: this.$route.params.id == "new" ? 0 : this.$route.params.id,
            recordToEdit: {},
            currentEdit: {},
            formType: [
                {
                    label: "銀行代號",
                    key: "coopBankId",
                    type: "select",
                    options: [],
                    filterable: true
                },
                {
                    label: "存單帳號",
                    key: "accountNumber",
                    type: "input"
                },
                {
                    label: "存單號碼",
                    key: "orderId",
                    type: "input"
                },
                {
                    label: "存單金額",
                    key: "amount",
                    type: "input",
                    addcomma: true
                },
                {
                    label: "存款計息方式",
                    key: "interestCalcFiexd",
                    type: "select",
                    options: [
                        {
                            label: "機動利率",
                            value: 0
                        },
                        {
                            label: "固定利率",
                            value: 1
                        }
                    ]
                },
                {
                    label: "存款年利率",
                    key: "annualInterestRate",
                    type: "input"
                },
                {
                    label: "存款月數",
                    key: "depositMonth",
                    type: "input",
                    append: "個月"
                },
                {
                    label: "起存日期",
                    key: "startDate",
                    type: "date"
                },

                {
                    label: "到期日期",
                    key: "endDate",
                    type: "date",
                    disabled: true
                },
                {
                    type: "button",
                    buttonType: "primary",
                    plain: true,
                    button: "建立提醒工作",
                    buttonKey: "endDateNotify"
                },
                {
                    label: "印鑑名稱",
                    key: "sealName",
                    type: "input"
                },
                {
                    label: "保管人姓名",
                    key: "custodian",
                    type: "input"
                },
                {
                    label: "備註",
                    key: "note",
                    type: "textarea"
                },
                {
                    title: "科目設定",
                    type: "title"
                },
                {
                    label: "對應活存科目",
                    key: "demandDepositAccountTitleId",
                    type: "select",
                    filterable: true,
                    options: []
                },
                {
                    label: "定存科目",
                    key: "timeDepositAccountTitleId",
                    type: "select",
                    filterable: true,
                    options: []
                },
                {
                    label: "定存利息科目",
                    key: "timeDepositInterestAccountTitleId",
                    type: "select",
                    filterable: true,
                    options: []
                }
            ],
            formTypeWork: [
                {
                    label: "標題",
                    key: "caption",
                    type: "input"
                },
                {
                    label: "起始日期",
                    key: "startDate",
                    type: "date"
                },
                {
                    label: "結束日期",
                    key: "endDate",
                    type: "date"
                },
                {
                    type: "post",
                    key: "objectKey",
                    value: 0
                },
                {
                    label: "工作內容",
                    key: "htmlContent",
                    type: "textarea"
                },
                {
                    label: "相關連結",
                    key: "url",
                    type: "input"
                },
                {
                    type: "button",
                    buttonType: "primary",
                    plain: true,
                    button: "前往",
                    buttonKey: "goLink"
                },
                {
                    label: "重要程度",
                    key: "levelKey",
                    type: "select",
                    options: [
                        {
                            label: "一般",
                            value: 1
                        },
                        {
                            label: "重要",
                            value: 2
                        },
                        {
                            label: "非常重要",
                            value: 3
                        }
                    ]
                },
                {
                    key: "notifyByEmail",
                    type: "checkbox",
                    options: [
                        {
                            label: "email通知"
                        }
                    ]
                },
                {
                    key: "emailNotifyTime",
                    type: "datetime",
                    vif: false
                },
                {
                    key: "notifyBySms",
                    type: "checkbox",
                    options: [
                        {
                            label: "簡訊通知"
                        }
                    ]
                },
                {
                    key: "smsNotifyTime",
                    type: "datetime",
                    vif: false
                }
            ],
            rules: {
                accountNumber: [
                    { required: true, message: "請輸入帳號", trigger: "blur" }
                ],
                amount: [
                    { required: true, message: "請輸入金額", trigger: "blur" }
                ],
                annualInterestRate: [
                    { required: true, message: "請輸入存款年利率", trigger: "blur" }
                ],
                demandDepositAccountTitleId: [
                    { required: true, message: "請選擇對應活存科目", trigger: "change" }
                ]
            }
        };
    },
    created() {
        this.getData();
    },
    watch: {
        // 初次載入沿用後端既有到期日期，避免已續存的存單被用起存日期重算
        "recordToEdit.startDate"(val) {
            if (this.isInitLoading) return;
            this.setEndDate(val, this.recordToEdit.depositMonth);
        },
        "recordToEdit.depositMonth"(val) {
            if (this.isInitLoading) return;
            this.setEndDate(this.recordToEdit.startDate, val);
        }
    },
    methods: {
        /**
         * 依起存日期與存款月數算出到期日期，同步寫回 recordToEdit 與畫面
         * ListForm 的民國日期是裸 input 不走 v-model，所以顯示要自己補寫
         * @param {string} startDate 起存日期(西元 YYYY-MM-DD)
         * @param {number|string} depositMonth 存款月數
         */
        setEndDate(startDate, depositMonth) {
            if (!startDate || !depositMonth) return;
            const endDate = moment(startDate)
                .add(Number(depositMonth), "month")
                .format("YYYY-MM-DD");
            this.$set(this.recordToEdit, "endDate", endDate);
            // 限定主表單內的欄位，避免蓋到「建立提醒工作」彈窗裡同名的 endDate
            if (this.$refs.mainForm) {
                $(".endDate", this.$refs.mainForm.$el).val(
                    `${parseInt(endDate) - 1911}${endDate.slice(4)}`
                );
            }
        },
        async getData() {
            const url = API.coopNtDepositOrder + `?id=${this.id}`;
            try {
                const json = await this.mAxiosGet(url);
                const data = json.resultData.data;
                // 新增時預設起存日期為今天
                if (this.id === 0 && !data.startDate) {
                    data.startDate = moment().format("YYYY-MM-DD");
                }

                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    data
                );
                if (this.id === 0) {
                    this.setEndDate(data.startDate, data.depositMonth);
                }
                // 銀行代號
                this.formType[0].options = json.resultData.enumData.bank.map(
                    item => {
                        return {
                            label: `${item.bankCode}-${item.bankName}`,
                            value: Number(item.id)
                        };
                    }
                );
                // 對應會計科目
                this.formType[14].options = json.resultData.enumData.accountTitle.map(
                    colAccountTitleTitle => {
                        return {
                            label: `${colAccountTitleTitle.code} ${colAccountTitleTitle.name}`,
                            value: colAccountTitleTitle.id
                        };
                    }
                );
                this.formType[15].options = json.resultData.enumData.accountTitle.map(
                    colAccountTitleTitle => {
                        return {
                            label: `${colAccountTitleTitle.code} ${colAccountTitleTitle.name}`,
                            value: colAccountTitleTitle.id
                        };
                    }
                );
                this.formType[16].options = json.resultData.enumData.accountTitle.map(
                    colAccountTitleTitle => {
                        return {
                            label: `${colAccountTitleTitle.code} ${colAccountTitleTitle.name}`,
                            value: colAccountTitleTitle.id
                        };
                    }
                );
            } catch (error) {
                console.error("Data retrieval failed.");
            } finally {
                // watcher 是排進佇列等 nextTick 才跑的，旗標要同樣排在 nextTick 才關；
                // 直接指派 false 會讓回填 recordToEdit 觸發的 watcher 讀到 false 而重算到期日期
                this.$nextTick(() => {
                    this.isInitLoading = false;
                });
            }
        },
        endDateNotify() {
            this.dialogListForm = true;
        },
        goLink() {
            window.open(this.currentEdit.url);
        },
        saveDialogEdit() {
            this.$refs.formSave.submitForm("recordToEdit");
        }
    }
};
</script>